import { AppState } from 'redux/reducers';

export const getHlsPlayerData = ({ videoStream }: AppState) => videoStream.hlsPlayerData;
export const getBetRadarPlayerUrl = ({ videoStream }: AppState) => videoStream.betRadarPlayerUrl;
export const getVideoStreamError = ({ videoStream }: AppState) => videoStream.error;
